module.exports = __webpack_public_path__ + "static/media/How can I link emails with Visa types.c9402387.png";